<template>
    <div class="lawsuit_info no-trans" v-loading="loading">
        <div class="box1">
            <div class="title_box">
                <div class="borders"></div>
                <div class="titles">
                    {{ ls_detial.name }}律师简介
                </div>
            </div>
            <div class="text_imgs">
                <div class="jianjie">
                   {{ ls_detial.info }}
                </div>
                <div class="imgs" v-if="!mobile_view">
                    <img src="../../../assets/img/index/legal/bg1.png" alt="">
                </div>
            </div>
            
        </div>
        <div class="box2">
            <div class="box_inof">
                <div class="title_box">
                    <div class="borders"></div>
                    <div class="titles">
                        联系方式
                    </div>
                </div>
                <div class="info_box">
                    <div class="info_flex">
                        <div class="info_title">联系电话</div>
                        <div class="info_text">{{ ls_detial.mobile }}</div>
                    </div>
                    <div class="info_flex">
                        <div class="info_title">微信</div>
                        <div class="info_text">{{ ls_detial.wx }}</div>
                    </div>
                    <div class="info_flex">
                        <div class="info_title">邮箱</div>
                        <div class="info_text">{{ ls_detial.email }}</div>
                    </div>
                    <div class="info_flex">
                        <div class="info_title">联系地址</div>
                        <div class="info_text">{{ ls_detial.mobile_address }}</div>
                    </div>
                </div>
            </div>
            <div class="box_inof">
                <div class="title_box">
                    <div class="borders"></div>
                    <div class="titles">
                        执业信息
                    </div>
                </div>
                <div class="info_box">
                    <div class="info_flex">
                        <div class="info_title">执业律所</div>
                        <div class="info_text">{{ ls_detial.work_company }}</div>
                    </div>
                    <div class="info_flex">
                        <div class="info_title">律所规模</div>
                        <div class="info_text">{{ ls_detial.company_guimo }}</div>
                    </div>
                    <div class="info_flex">
                        <div class="info_title">职务</div>
                        <div class="info_text">{{ ls_detial.zhiwu }}</div>
                    </div>
                    <div class="info_flex">
                        <div class="info_title">执业证号</div>
                        <div class="info_text">{{ ls_detial.license_num }}</div>
                    </div>
                    <div class="info_flex">
                        <div class="info_title">执业年份</div>
                        <div class="info_text">{{ ls_detial.business_year }}</div>
                    </div>
                    <div class="info_flex">
                        <div class="info_title">团队描述</div>
                        <div class="info_text">{{ ls_detial.team_info }}</div>
                    </div>
                </div>
            </div>
            <div class="box_inof">
                <div class="title_box">
                    <div class="borders"></div>
                    <div class="titles">
                        教育背景
                    </div>
                </div>
                <div class="info_box">
                    <div class="info_flex">
                        <div class="info_title">最高学历</div>
                        <div class="info_text">{{ ls_detial.max_edu }}</div>
                    </div>
                    <div class="info_flex">
                        <div class="info_title">毕业院校</div>
                        <div class="info_text">{{ ls_detial.school }}</div>
                    </div>
                    <div class="info_flex">
                        <div class="info_title">所学专业</div>
                        <div class="info_text">{{ ls_detial.major }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'



export default {
    components: {
        
    },
    props:{
       
        ls_detial:{
            type: Object,
            default: {},
		},
    },
    name: "homes",
    data() {
        return {
            loading:false,
            
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {

    },
    methods: {
        
    },

}
</script>
<style scoped lang="less">
.lawsuit_info{
    padding-top: 24px;
    .title_box{
        display: flex;
        // align-items: center;
        padding-top: 24px;
        padding-right: 32px;
        .borders{
            width: 4px;
            height: 22px;
            background: #377CFD;
            border-radius: 3px 3px 3px 3px;
        }
        .titles{
            flex: 1;
            // padding-left: 32px;
            margin-left: 28px;
            padding-bottom: 24px;
            border-bottom: 1px solid #D7D7D7;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            span{
                color: #377CFD;
            }
        }
    }
    .box1{
        min-height: 519px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .text_imgs{
            display: flex;
            // align-items: center;
            justify-content: space-between;
            padding: 48px 32px;
            .jianjie{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                padding-right: 42px;
                line-height: 36px;
            }
            .imgs{
                width: 604px;
                height: 351px;
                flex-shrink: 0;
                img{
                    width: 604px;
                    height: 351px;
                }
            }
        }
    }
    .box2{
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .box_inof{
            width: 464px;
            height: 308px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            .info_box{
                padding: 24px 32px;
                .info_flex{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .info_title{
                        width: 60px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                    }
                    .info_text{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        padding-left: 32px;
                    }
                }
            }
        }
    }
   
    
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .lawsuit_info.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-top: 16px;
    }
    .lawsuit_info.no-trans .title_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
        padding-right: 16px;
    }
    .lawsuit_info.no-trans .title_box .borders {
        width: 4px;
        height: 22px;
        border-radius: 3px 3px 3px 3px;
    }
    .lawsuit_info.no-trans .title_box .titles {
        margin-left: 16px;
        padding-bottom: 16px;
        font-size: 18px;
    }
    .lawsuit_info.no-trans .box1 {
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
    }
    .lawsuit_info.no-trans .box1 .text_imgs {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 16px 16px;
    }
    .lawsuit_info.no-trans .box1 .text_imgs .jianjie {
        font-size: 16px;
        padding-right: 16px;
        line-height: 36px;
    }
    .lawsuit_info.no-trans .box1 .text_imgs .imgs {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
    }
    .lawsuit_info.no-trans .box1 .text_imgs .imgs img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .lawsuit_info.no-trans .box2 {
        margin-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .lawsuit_info.no-trans .box2 .box_inof {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
    }
    .lawsuit_info.no-trans .box2 .box_inof .info_box {
        padding: 16px 16px;
    }
    .lawsuit_info.no-trans .box2 .box_inof .info_box .info_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 10px;
    }
    .lawsuit_info.no-trans .box2 .box_inof .info_box .info_flex .info_title {
        width: 60px;
        font-size: 14px;
    }
    .lawsuit_info.no-trans .box2 .box_inof .info_box .info_flex .info_text {
        font-size: 14px;
        padding-left: 16px;
    }
}
</style>
